<template>
    <svg
        viewBox="0 0 32 32"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M28.9259 7.00233L25.0023 25.672C24.706 26.9894 23.9343 27.3174 22.8375 26.6971L16.8588 22.252L13.9743 25.0517C13.6549 25.3741 13.3883 25.643 12.7726 25.643L13.2026 19.5L24.2826 9.39824C24.7645 8.96534 24.1776 8.72453 23.534 9.15836L9.83616 17.8612L3.93911 15.9985C2.65661 15.5946 2.6334 14.7045 4.20656 14.0832L27.2719 5.11709C28.3399 4.71324 29.2742 5.35602 28.9259 7.00233Z"
            fill="currentColor"
        />
    </svg>
</template>
